
import React from 'react';
import Button from '../../../components/base/Button';

const HeroSection: React.FC = () => {
  return (
    <section 
      id="inicio"
      className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(33, 65, 52, 0.8), rgba(33, 65, 52, 0.8)), url('https://readdy.ai/api/search-image?query=Modern%20elegant%20law%20office%20interior%20without%20people%2C%20sophisticated%20legal%20environment%20with%20wooden%20desk%20and%20bookshelves%20filled%20with%20law%20books%20in%20soft%20focus%20background%2C%20warm%20natural%20lighting%20from%20large%20windows%2C%20professional%20atmosphere%20with%20neutral%20and%20warm%20tones%20compatible%20with%20dark%20green%20and%20gold%20colors%2C%20subtle%20depth%20of%20field%20with%20bokeh%20effect%2C%20realistic%20photography%20style%2C%20clean%20and%20welcoming%20workspace%20with%20legal%20documents%20and%20certificates%20on%20walls%2C%20premium%20wooden%20furniture%20and%20soft%20ambient%20lighting&width=1920&height=1080&seq=hero-law-office&orientation=landscape')`
      }}
    >
      <div className="container mx-auto px-4 py-20">
        <div className="w-full">
          {/* Conteúdo Principal */}
          <div className="text-white space-y-6 max-w-4xl">
            <div className="space-y-4">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                Especialista em Direito Previdenciário:
                <span className="text-[#cc9b3f] block">17 Anos Protegendo Seus Direitos</span>
              </h1>
              <p className="text-xl md:text-2xl text-gray-200 leading-relaxed">
                Atendimento humanizado para pessoas com deficiência, aposentadorias e isenção de IR por doença grave.
              </p>
            </div>

            {/* Diferenciais */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-8">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-[#cc9b3f] rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-[#214134] font-bold"></i>
                </div>
                <span className="text-lg">Atuação Especializada</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-[#cc9b3f] rounded-full flex items-center justify-center">
                  <i className="ri-heart-line text-[#214134] font-bold"></i>
                </div>
                <span className="text-lg">Atendimento Humanizado</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-[#cc9b3f] rounded-full flex items-center justify-center">
                  <i className="ri-user-line text-[#214134] font-bold"></i>
                </div>
                <span className="text-lg">Advogada PCD</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-[#cc9b3f] rounded-full flex items-center justify-center">
                  <i className="ri-time-line text-[#214134] font-bold"></i>
                </div>
                <span className="text-lg">30+ Anos Experiência</span>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 pt-6">
              <Button 
                href="https://wa.me/5544988019071?text=Olá! Gostaria de agendar uma consulta sobre direito previdenciário."
                target="_blank"
                size="lg"
                className="text-lg"
              >
                <i className="ri-whatsapp-line mr-3 text-xl"></i>
                Agende sua Consulta
              </Button>
              <Button 
                variant="outline"
                size="lg"
                className="text-lg border-white text-white hover:bg-white hover:text-[#214134]"
                onClick={() => {
                  const element = document.getElementById('servicos');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-service-line mr-3 text-xl"></i>
                Nossos Serviços
              </Button>
            </div>

            {/* Informações de Contato */}
            <div className="flex flex-col sm:flex-row gap-6 pt-8 text-gray-200">
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line text-[#cc9b3f]"></i>
                <span>(44) 98801-9071</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-map-pin-line text-[#cc9b3f]"></i>
                <span>Maringá/PR - Atendimento Nacional</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
